import { createSlice, Dispatch, PayloadAction } from '@reduxjs/toolkit';
import { FilterReservationsQueryParams, PagedReservationsList } from 'app/types/service-types/ReservationTypes';
import { ReservationService } from 'app/services';
import { errorMsg } from 'app/utils/MessageUtils';
import { AxiosError } from 'axios';

export const fetchAllSchedules =
  (queryParams?: FilterReservationsQueryParams) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      let response: PagedReservationsList;

      if (queryParams && Object.keys(queryParams).length > 0) {
        response = await ReservationService.searchReservations(queryParams);
      } else {
        response = await ReservationService.fetchAll();
      }

      dispatch(setAllReservations(response));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));

      // Narrow the unknown error
      const err = error as AxiosError<{ message?: string }> | Error | any;

      const message =
        err?.response?.data?.message ||
        err?.data?.message ||
        err?.message ||
        'Something went wrong while fetching reservations.';

      dispatch(errorMsg(message));
    }
  };

interface SchedulesListSlice {
  allReservations: PagedReservationsList | null;
  loading: boolean;
}

const initialState: SchedulesListSlice = {
  allReservations: null,
  loading: false,
};

const stateSlice = createSlice({
  name: 'schedules/schedules-list',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setAllReservations: (state, action: PayloadAction<PagedReservationsList>) => {
      state.allReservations = action.payload;
    },
  },
});

export const { setLoading, setAllReservations } = stateSlice.actions;
export default stateSlice.reducer;
